import { Controller } from "@hotwired/stimulus"
import React, { Suspense } from "react"
import { render, unmountComponentAtNode } from "react-dom"
import { ErrorBoundary, Loading, ModalContainer } from "web/components"
import { BrowserRouter as Router } from "react-router-dom"

import { ObjectList } from "web/components"
import { NavigationProvider } from "web/contexts"
import { AppProviders, LibraryProviders } from "web/Providers"

export default class ObjectListController extends Controller {
  static values = {
    basePath: String,
    viewGroup: Object,
    viewId: Number,
    availableViews: Array,
    subjectType: String,
    defaultView: String,
    itemClickBaseUrl: String,
    addItemUrl: String,
    parentSubjectType: String,
    parentSubjectId: Number,
    enableLocationIndex: Boolean,
    enableScheduledExport: Boolean,
    enableCreation: { default: false, type: Boolean },
    enableEdit: { default: true, type: Boolean },
    enableExport: { default: true, type: Boolean },
    exportPath: String,
    isFavouriteEnabled: { default: true, type: Boolean },
    fetchUrl: String,
  }

  initialize() {
    global.React = React
  }

  onItemClick(item) {
    window.Turbo.visit(`${this.itemClickBaseUrlValue}/${item.id}`)
  }

  onAdd() {
    window.Turbo.visit(this.addItemUrlValue, { frame: "modal" })
  }

  disconnect() {
    unmountComponentAtNode(this.element)
  }

  connect() {
    const parentSubjectType = this.hasParentSubjectTypeValue
      ? this.parentSubjectTypeValue
      : undefined

    const parentSubjectId = this.hasParentSubjectIdValue
      ? this.parentSubjectIdValue
      : undefined

    render(
      <Suspense fallback={<Loading />}>
        <Router>
          <LibraryProviders>
            <AppProviders>
              <NavigationProvider
                viewGroup={this.viewGroupValue}
                viewId={this.viewIdValue}
                subjectType={this.subjectTypeValue}
              >
                <ErrorBoundary>
                  <ObjectList
                    subjectType={this.subjectTypeValue}
                    availableViews={this.availableViewsValue}
                    defaultView={this.defaultViewValue}
                    enableEdit={this.enableEditValue}
                    enableExport={this.enableExportValue}
                    exportPath={this.exportPathValue}
                    onItemClick={this.onItemClick.bind(this)}
                    onAdd={this.enableCreationValue && this.onAdd.bind(this)}
                    rootUrl={this.basePathValue}
                    canRedirectToRootUrl={false}
                    parentSubjectType={parentSubjectType}
                    parentSubjectId={parentSubjectId}
                    enableLocationIndex={this.enableLocationIndexValue}
                    enableScheduledExport={this.enableScheduledExportValue}
                    isFavouriteEnabled={this.isFavouriteEnabledValue}
                    fetchURL={this.fetchUrlValue}
                  />
                </ErrorBoundary>
              </NavigationProvider>
              <ModalContainer />
            </AppProviders>
          </LibraryProviders>
        </Router>
      </Suspense>,
      this.element
    )
  }
}
